import { Link } from "react-router-dom";
import { NAV_LINKS, WHATSAPP_DISPLAY, waLink, DEFAULT_WA_MESSAGE } from "../config/site";
import { LEGAL, isLegalFieldSet } from "../config/legal";
import { METIERS } from "../data/metiers";
import { WhatsAppIcon } from "./Cta";

const LEGAL_LINKS = [
  { to: "/mentions-legales", label: "Mentions légales" },
  { to: "/conditions-generales-de-prestation", label: "Conditions générales de prestation" },
  { to: "/cgu", label: "Conditions générales d'utilisation" },
  { to: "/politique-de-confidentialite", label: "Politique de confidentialité" },
  { to: "/politique-cookies", label: "Politique cookies" },
];

export default function Footer() {
  return (
    <footer className="grain relative bg-nuit-950 text-white">
      <div className="container-nv grid gap-12 py-16 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <img src="/assets/logo-white.png" alt="Noveocard" className="h-7 w-auto" width="150" height="21" loading="lazy" />
          <p className="mt-4 max-w-xs font-display text-lg font-medium text-electric-300">
            Votre identité. En version digitale.
          </p>
          <p className="mt-3 max-w-xs text-sm leading-relaxed text-white/60">
            Cartes digitales professionnelles premium, personnalisées à votre image. La porte d'entrée
            vers votre univers digital.
          </p>
          <a
            href={waLink(DEFAULT_WA_MESSAGE)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-cta-whatsapp"
            className="mt-6 inline-flex items-center gap-2 rounded-full bg-electric px-5 py-2.5 font-display text-sm font-semibold text-white transition-[transform,background-color] duration-300 hover:-translate-y-0.5 hover:bg-electric-600"
          >
            <WhatsAppIcon className="h-4 w-4" /> {WHATSAPP_DISPLAY}
          </a>
        </div>

        <nav aria-label="Plan du site">
          <p className="font-display text-sm font-semibold uppercase tracking-[0.2em] text-white/40">Navigation</p>
          <ul className="mt-4 space-y-2.5 text-sm">
            {NAV_LINKS.map(({ to, label }) => (
              <li key={to}>
                <Link to={to} className="text-white/70 transition-colors hover:text-white">
                  {label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/galerie" className="text-white/70 transition-colors hover:text-white">
                Galerie
              </Link>
            </li>
            <li>
              <Link to="/faq" className="text-white/70 transition-colors hover:text-white">
                FAQ
              </Link>
            </li>
            <li>
              <Link to="/conseils" className="text-white/70 transition-colors hover:text-white">
                Conseils
              </Link>
            </li>
          </ul>
        </nav>

        <nav aria-label="Solutions par métier">
          <p className="font-display text-sm font-semibold uppercase tracking-[0.2em] text-white/40">Solutions</p>
          <ul className="mt-4 space-y-2.5 text-sm">
            {METIERS.slice(0, 8).map((m) => (
              <li key={m.slug}>
                <Link to={`/solutions/${m.slug}`} className="text-white/70 transition-colors hover:text-white">
                  {m.name}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/solutions" className="font-medium text-electric-300 transition-colors hover:text-electric-200">
                Toutes les solutions →
              </Link>
            </li>
          </ul>
        </nav>

        <nav aria-label="Pages légales">
          <p className="font-display text-sm font-semibold uppercase tracking-[0.2em] text-white/40">Légal</p>
          <ul className="mt-4 space-y-2.5 text-sm">
            {LEGAL_LINKS.map(({ to, label }) => (
              <li key={to}>
                <Link to={to} className="text-white/70 transition-colors hover:text-white">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <div className="border-t border-white/10">
        <div className="container-nv flex flex-col items-center justify-between gap-3 py-6 text-xs text-white/45 sm:flex-row">
          <p>© {new Date().getFullYear()} Noveocard — Cartes digitales professionnelles premium.</p>
          {isLegalFieldSet(LEGAL.operateur) && (
            <p>
              {LEGAL.operateur}
              {isLegalFieldSet(LEGAL.siret) ? ` — SIRET ${LEGAL.siret}` : ""}
            </p>
          )}
          <p>Cartes NFC personnalisées à partir de 40 € TTC</p>
        </div>
      </div>
    </footer>
  );
}
